import { render, staticRenderFns } from "./exchangeGifts.vue?vue&type=template&id=3642edf8&scoped=true&"
import script from "./exchangeGifts.vue?vue&type=script&lang=js&"
export * from "./exchangeGifts.vue?vue&type=script&lang=js&"
import style0 from "./exchangeGifts.vue?vue&type=style&index=0&id=3642edf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3642edf8",
  null
  
)

export default component.exports